// components
import { Grid } from '@interstate/components/Grid';
import { NumericInput } from '@interstate/components/NumericInput';
import { useState } from 'react';
import { createPriceValidationOnBlurHandler } from '../../../../utils';

import { getCompactGridBreakpoints } from './getCompactGridBreakpoints';

export type VehicleRowDataInputProps = {
    onSellingPriceChange: (value: string) => void;
    onOdometerChange: (value: string) => void;
    onMsrpChange: (value: string) => void;
    msrp?: string;
    odometer: string;
    minOdometerValue: number;
    sellingPrice: string;
    vin: string;
    isMsrpRequired: boolean;
    forceSmallBreakpoint?: boolean;
};

export const EditVehicle = (props: VehicleRowDataInputProps) => {
    const {
        odometer,
        sellingPrice,
        msrp,
        onOdometerChange,
        onSellingPriceChange,
        onMsrpChange,
        minOdometerValue,
        vin,
        isMsrpRequired
    } = props;

    const [msrpError, setMsrpError] = useState<string>('');
    const [sellingPriceError, setSellingPriceError] = useState<string>('');

    return (
        <>
            <Grid
                container
                columnSpacing={2}
                marginTop={2}
                sx={{ '& .ids-input-component-label': { whiteSpace: 'nowrap!important' } }}
            >
                <Grid {...getCompactGridBreakpoints({ xs: 12, md: 4, forceSmallBreakpoint: props.forceSmallBreakpoint })}>
                    <NumericInput
                        placeholder="0.00"
                        name="MSRP"
                        label={isMsrpRequired ? 'MSRP' : 'Retail Price'}
                        value={msrp}
                        onChange={(e) => onMsrpChange(e.target.value)}
                        onBlur={createPriceValidationOnBlurHandler(
                            isMsrpRequired ? 'MSRP' : 'Retail Price',
                            msrp || '',
                            onMsrpChange,
                            setMsrpError,
                            isMsrpRequired
                        )}
                        data-testid={isMsrpRequired ? `custom-msrp-${vin}` : `custom-retail-price-${vin}`}
                        required={isMsrpRequired}
                        allowDecimal
                        decimalMaxLength={2}
                        decimalMinLength={0}
                        inputPrefix={'$'}
                        autoInsertCommas
                        errorMessage={msrpError}
                        hasError={!!msrpError}
                    />
                </Grid>
                <Grid {...getCompactGridBreakpoints({ xs: 12, md: 4, forceSmallBreakpoint: props.forceSmallBreakpoint })}>
                    <NumericInput
                        placeholder="0.00"
                        name="Selling Price"
                        label="Selling Price"
                        value={sellingPrice}
                        onChange={(e) => onSellingPriceChange(e.target.value)}
                        onBlur={createPriceValidationOnBlurHandler(
                            'Selling Price',
                            sellingPrice,
                            onSellingPriceChange,
                            setSellingPriceError,
                            true
                        )}
                        data-testid={`custom-selling-price-${vin}`}
                        required
                        allowDecimal
                        decimalMaxLength={2}
                        decimalMinLength={0}
                        inputPrefix={'$'}
                        autoInsertCommas
                        errorMessage={sellingPriceError}
                        hasError={!!sellingPriceError}
                    />
                </Grid>
                <Grid {...getCompactGridBreakpoints({ xs: 12, md: 4, forceSmallBreakpoint: props.forceSmallBreakpoint })}>
                    <NumericInput
                        placeholder="0"
                        name="Odometer"
                        label={'Odometer'}
                        value={odometer || '0'}
                        onChange={(e) => onOdometerChange(e.target.value)}
                        data-testid={`custom-odometer-${vin}`}
                        required
                        allowDecimal={false}
                        autoInsertCommas
                        minValue={minOdometerValue}
                        customErrorMessages={{
                            lessThanMinValue: 'The value should be greater than 0.'
                        }}
                    />
                </Grid>
            </Grid>
        </>
    );
};
